module.exports = __webpack_public_path__ + "static/Gallery-13-9c9494bb974fdd0e787786c3d85d8cdd.jpg";